export default "__VITE_ASSET__BtqROc9q__"